<template>
  <div>
    <div class="app-title">
      <em-view-title ref="emViewTitle" v-bind:crudState="pathType"></em-view-title>
    </div>

    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionFilter"
          >
            <div class="card-body">
              <!--                            <b-alert show class="content">-->
              <b-container fluid>
                <b-row>
                  <b-col  md="2">
                    <b-input type="text" v-model="bdaNameFilter" placeholder="请输入设备名称作为过滤条件"></b-input>
                  </b-col>
                </b-row>
                <!-- User Interface controls -->
                <b-row>
                  <b-col v-for="(value, key) in getFiles(items)" :key="key" md="2" class="my-1">
                    <strong>{{ key }} :</strong>
                    {{ value }}
                  </b-col>
                </b-row>
                <b-row v-if="executeCardEdit">
                  <b-col md="10" class="my-1"></b-col>
                  <b-col md="2" class="my-1">
                    <b-button-group>
                      <em-button type="readOpc" :class="'btn btn-outline-primary'"
                                 customLabel="读取OPC实测值"
                                 showName
                                 v-menu-permission="'edit'"
                                 @click="getOpcDataAndInitialData"></em-button>
                      <em-button type="approve" :class="'btn btn-primary'"
                                 customLabel="btn.em.epi.finishInspection"
                                 showName
                                 v-menu-permission="'edit'"
                                 @click="handleFinishInspection"></em-button>
                      <em-button type="cancel" :class="'btn btn-outline-warning'"
                                 customLabel="btn.em.epi.deprecatedInspection"
                                 showName
                                 v-menu-permission="'edit'"
                                 @click="handleDeprecatedInspection"></em-button>
                      <em-button type="cancel" :class="'btn btn-outline-primary'"
                                 showName
                                 @click="handleCancel"></em-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </b-container>
              <!--                            </b-alert>-->
            </div>
          </div>
        </div>
      </div>
      <div id="ArchListResultTable" class="content">
        <div class="card my-1">
          <div
              id="collapseTwo"
              class="collapse show"
              aria-labelledby="headingTwo"
              data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="card-columns">
                <InspectionExecuteCard
                    v-for="cardData in cardDatas"
                    :key="cardData.id"
                    :fields="fields"
                    :inspectionScheduleEquipmentVo="cardData"
                    :enableEdit="executeCardEdit"
                    @showDetail="handleShowDetail"
                    @addRecord="verifyHandleAddClick"
                    @editRecord="handleEditClick"
                    @deleteRecord="handleDeleteClick"
                ></InspectionExecuteCard>
              </div>
              <!-- Info modal -->
              <!--                            <b-modal id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>-->
              <!--                                <pre>{{ modalInfo.content }}</pre>-->
              <!--                            </b-modal>-->
              <b-modal ref="modalDetail" centered hide-footer :title="itemDetail.name" size="lg">
                <b-table
                    striped
                    hover
                    responsive
                    caption-top
                    :items="itemDetail.inspectionScheduleDetailVoList"
                    :fields="detailFields"
                    show-empty
                    stacked="md"
                ></b-table>
              </b-modal>

              <b-modal ref="handleIpVerifyModal" cancel-disabled>
                IP地址验证已开启：当前用户登录IP地址，不在点检设备允许点检IP地址范围
              </b-modal>
              <b-modal ref="inspectionRecordEditModal" size="lg"
                       @ok="handleInspectionRecordEditModalOk">
                <em-entity-edit-form :entity="inspectionRecordEntity" saveButtonDisable></em-entity-edit-form>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import {createHelpers} from "vuex-map-fields";
import EmViewTitle from "@/components/em/EmViewTitle";
import EmButton from "@/components/em/EmButton";
import InspectionExecuteCard from "@/views/em/inspection/components/InspectionExecuteCard";
import EmEntityEditForm from "@/components/em/EmEntity/EditForm";
import EmCommonApi from "@/mixin/em/common/api";

const {mapFields: recordMapFields} = createHelpers({
  getterType: "inspectionRecordForInspection/getField",
  mutationType: "inspectionRecordForInspection/updateField"
});

const {mapFields} = createHelpers({
  getterType: "inspectionWorkOrder/getField",
  mutationType: "inspectionWorkOrder/updateField"
});
export default {
  name: "inspectionExecute",
  mixins: [EmCommonApi],
  components: {EmViewTitle, InspectionExecuteCard, EmButton, EmEntityEditForm},
  // props: {
  //     workOrderId: {
  //         type: String,
  //         required: true
  //     },
  //     //todo：有了pathType了和userBy功能就重叠了，想一下，到底用哪个，先留着
  //     usedBy: {
  //         type: String,
  //         default: "execute",
  //         validator: function (value) {
  //             // 这个值必须匹配下列字符串中的一个
  //             return ["showDetail", "execute"].indexOf(value) !== -1;
  //         }
  //     }
  // },
  data() {
    return {
      bdaNameFilter: "",
      items: {},
      inspectionRecordEntity: "inspectionRecordForInspection",
      //给modal显示的内容
      itemDetail: {},
      popoverTarget: String,
      //默认list，todo才可以编辑
      pathType: this.$route.query.pathType ? this.$route.query.pathType : 'list',
      detailFields: [
        {key: "name", label: "点检项目名"},
        {key: "projectName", label: "点检标准名"},
        {key: "inspectionRecordVo.inspectionResultName", label: "点检结果"},
        {key: "inspectionRecordVo.recordValue", label: "点检值"},
        {key: "inspectionRecordVo.abnormalDescription", label: "点检备注"},
        {key: "inspectionRecordVo.processStatusName", label: "异常工单处理状态"},//todo：不一定有，先看看
        {key: "inspectionRecordVo.handleDescription", label: "处理方式"},//todo：不一定有，先看看
        {key: "inspectionContents", label: "点检内容"},
        {key: "inspectionStandards", label: "点检标准"},
        {key: "equipmentStatus", label: "设备选定状态"},
        {key: "inspectionValueTypeName", label: "点检值分类名"},
        {key: "inspectionValueTypeUnit", label: "点检值分类单位"},
        {key: "inspectionWay", label: "点检方法"},
        {key: "warningUpperLimit", label: "警告上限"},
        {key: "warningLowerLimit", label: "警告下限"},
        {key: "dangerUpperLimit", label: "报警上限"},
        {key: "dangerLowerLimit", label: "报警下限"}
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 20,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      modalInfo: {title: "", content: ""},
      inspVerifyStatusCode: ""
    };
  },
  computed: {
    cardDatas:{
      get() {
        if(this.bdaNameFilter) {
          return this.items.inspectionScheduleEquipmentVoList.filter(f => f.emArchBasicDataName && f.emArchBasicDataName.includes(this.bdaNameFilter))
        }
        else return this.items.inspectionScheduleEquipmentVoList
      },
      set(value){

      }

    },
    executeCardEdit() {
      if (this.$route.query.pathType && this.$route.query.pathType === 'todo') {
        return true;
      } else {
        return false;
      }
    },
    fields() {
      //编辑状态
      if (this.executeCardEdit) {
        return [
          {key: "name", label: "点检项目名"},
          {key: "projectName", label: "点检标准名"},
          {key: "inspectionRecordVo.inspectionResultName", label: "点检结果"},
          {key: "inspectionRecordVo.recordValue", label: "点检值"},
          {key: "dangerUpperLimit", label: "报警上限"},
          {key: "dangerLowerLimit", label: "报警下限"},
          {key: "actions", label: "操作功能"}
        ]
      }
      //查询状态
      else {
        return [
          {key: "name", label: "点检项目名"},
          {key: "projectName", label: "点检标准名"},
          {key: "inspectionRecordVo.inspectionResultName", label: "点检结果"},
          {key: "inspectionRecordVo.recordValue", label: "点检值"},
          {key: "inspectionRecordVo.dangerUpperLimit", label: "报警上限"},
          {key: "inspectionRecordVo.dangerLowerLimit", label: "报警下限"},
          {key: "inspectionRecordVo.abnormalStatus", label: "异常状态"}
        ]
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {text: f.label, value: f.key};
          });
    },
    workOrderId() {
      return this.items.id ? this.items.id : ''
    },
    ...mapFields({
      baseModuleUrl: "baseModuleUrl",
      'crudState': 'crudState',
      'businessData': 'processBusinessData',
      'businessKey': 'processBusinessData.id',
      'taskPathType': 'taskPathType',
    }),
    ...recordMapFields({
      recordCrudState: 'crudState',
      recordVuexEntity: "entity",
      recordTaskPathType: 'taskPathType',
    })
  },
  methods: {
    ...mapActions("api", {
      apiGet: "get",
      apiPost: "post"
    }),
    handleInspectionRecordEditModalOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleInspectionRecordEditModalSubmit()
    },
    handleInspectionRecordEditModalSubmit() {
      let url = this.baseModuleUrl + "/doInspection/inspectionRecord";
      if (this.recordCrudState === 'new') {
        this.$store.dispatch("api/post", {
          url,
          data: this.recordVuexEntity
        }).then(response => this.showSuccessAndRefresh(response))
      } else if (this.recordCrudState === 'edit') {
        this.$store.dispatch("api/put", {
          url,
          entity: this.recordVuexEntity
        }).then(response => this.showSuccessAndRefresh(response))
      }
    },
    //读取点巡检校验开关状态码
    getVerifyInspSwitchStatus() {
      let url = this.baseModuleUrl + "/doInspection/getVerifyInspSwitchStatus";
      this.$store.dispatch("api/get", {url}).then(
          res => {
            // console.log("点巡检校验开关状态码：")
            // console.log(res)
            this.inspVerifyStatusCode = res;
          }
      )
    },
    //是否校验"新增点检记录“按钮
    verifyHandleAddClick(inspectionScheduleDetailVo) {
      //判断点巡检状态开关码
      //如果是 11 ，那么开启设备卡片的验证
      if (this.inspVerifyStatusCode === "11") {
        //验证IP地址
        //点检值还是在提交”完成点检“的时候整体去验证哪个没有值

        let url = this.baseModuleUrl + "/doInspection/verifyIpAtEquipmentCard";

        this.$store.dispatch("api/post", {
          url,
          data: {bdaCode: inspectionScheduleDetailVo.emArchBasicDataCode}
        }).then(res => {
          if (res.data === false) {
            //alert("IP地址验证已开启：当前用户登录IP地址，不在设备[" + inspectionScheduleDetailVo.emArchBasicDataName + "]允许点检IP地址范围");
            //弹出验证失败拦截窗口
            this.$refs['handleIpVerifyModal'].show()
          } else {
            //弹出点检值录入窗口
            this.handleAddClick(inspectionScheduleDetailVo);
          }
        })
      } else {
        //弹出点检值录入窗口
        this.handleAddClick(inspectionScheduleDetailVo);
      }
    },
    //新增点检记录
    handleAddClick(inspectionScheduleDetailVo) {
      //设置crud状态
      this.recordCrudState = 'new';
      //设置无需手填的信息
      this.recordVuexEntity = {
        id: null,
        emArchBasicDataCode: inspectionScheduleDetailVo.emArchBasicDataCode,
        inspectionStandardId: inspectionScheduleDetailVo.inspectionStandardId,
        inspectionScheduleDetailId: inspectionScheduleDetailVo.id,
        inspectionWorkOrderId: this.workOrderId,
        inspectionResultId: '',
        recordValue: '',
        recorder: null,
        abnormalDescription: '',
        abnormalTime: null
      }
      //显示modal
      this.$refs['inspectionRecordEditModal'].show()
    },
    //修改点检记录
    handleEditClick(inspectionScheduleDetailVo) {
      //记录id不为空，才继续执行
      if (inspectionScheduleDetailVo.inspectionRecordVo.id) {
        //设置crud状态
        this.recordCrudState = 'edit';
        //新建entity
        //填充entity待修改值
        this.recordVuexEntity = {
          id: inspectionScheduleDetailVo.inspectionRecordVo.id,
          emArchBasicDataCode: inspectionScheduleDetailVo.inspectionRecordVo.emArchBasicDataCode,
          inspectionStandardId: inspectionScheduleDetailVo.inspectionRecordVo.inspectionStandardId,
          inspectionScheduleDetailId: inspectionScheduleDetailVo.inspectionRecordVo.inspectionScheduleDetailId,
          inspectionWorkOrderId: inspectionScheduleDetailVo.inspectionRecordVo.inspectionWorkOrderId,
          inspectionResultId: inspectionScheduleDetailVo.inspectionRecordVo.inspectionResultId,
          recordValue: inspectionScheduleDetailVo.inspectionRecordVo.recordValue,
          recorder: inspectionScheduleDetailVo.inspectionRecordVo.recorder,
          abnormalDescription: inspectionScheduleDetailVo.inspectionRecordVo.abnormalDescription,
          abnormalTime: inspectionScheduleDetailVo.inspectionRecordVo.abnormalTime
        }
        //显示modal
        this.$refs['inspectionRecordEditModal'].show()
      }
    },
    handleDeleteClick(inspectionScheduleDetailVo) {
      //记录id不为空，才继续执行
      if (inspectionScheduleDetailVo.inspectionRecordVo.id) {
        let url = this.baseModuleUrl + "/doInspection/inspectionRecord?id=" + inspectionScheduleDetailVo.inspectionRecordVo.id;
        this.$store.dispatch("api/delete", {url}).then(response => this.showSuccessAndRefresh(response))
      }
    },
    showSuccessAndRefresh(response) {
      //关闭modal
      this.$refs['inspectionRecordEditModal'].hide()
      //提示成功
      this.$store.dispatch("base/showSuccess", {
        userAlertSuccessStr: "保存成功",
        dismissCountDown: 5,
        userAlertSuccessVisible: false,
      }).then(() => {
        //刷新点检数据
        this.getWorkOrderVo();
      })

    },
    getFiles(item) {
      return {
        点检分类: item.inspectionCategoryName,
        点检计划名: item.inspectionScheduleName,
        执行人: item.executor,
        开始时间: item.startTime,
        执行时间: item.executeTime,
        状态: item.inspectionWorkOrderProcessStatusName
      };
    },
    handleShowDetail: function (item) {
      this.itemDetail = item;
      this.$refs.modalDetail.show();
    },
    getOpcDataAndInitialData() {
      //读取Opc实测值 getOpcDataAndInitialData
      //用途：created and @click
      let url = this.baseModuleUrl + "/doInspection/getOpcDataAndInitialData?workOrderId=" + this.businessKey
      console.log(url)
      this.apiGet({url}).then(responseData => {
        this.items = {};
        this.items = responseData
      })
    },
    //完成点检
    handleFinishInspection() {
      let url = this.baseModuleUrl + "/doInspection/completeInspectionTask?workOrderId=" + this.businessKey
      this.apiPost({url}).then(response => {
        if (response.data.processSituationDtoList[0].processStatus === "ENDED") {
          //提示点检完成
          this.$store.dispatch("base/showSuccess", {
            userAlertSuccessStr: "点检成功",
            dismissCountDown: 5,
            userAlertSuccessVisible: false,
          })
              //返回点检待办
              .then(() => {
                this.$refs.emViewTitle.$refs.emBreadCrumb.goBack();
              })

        }
      })
    },
    //作废点检
    handleDeprecatedInspection() {
      let url = this.baseModuleUrl + "/doInspection/deprecatedInspectionTask?workOrderId=" + this.businessKey
      this.apiPost({url}).then(response => {
        if (response.data.processStatus === "ENDED") {
          //提示点检已取消
          this.$store.dispatch("base/showSuccess", {
            userAlertSuccessStr: "点检已取消",
            dismissCountDown: 5,
            userAlertSuccessVisible: false,
          })
              //返回点检待办
              .then(() => {
                this.$refs.emViewTitle.$refs.emBreadCrumb.goBack();
              })

        }
      })
    },
    //取消，返回点检待办
    handleCancel() {
      this.$refs.emViewTitle.$refs.emBreadCrumb.goBack();
    },
    //获取点检数据模型
    getWorkOrderVo() {
        //【注意】2024.4.29 executeCardEdit固定传入true，是为了在查询点检记录时，看设备卡片仍然能match所有未结束异常待办；直到所有待办都处理掉，那么所有之前的记录都显示为正常了
      let url = this.baseModuleUrl + "/doInspection/inspectionTask?workOrderId=" + this.businessKey + "&executeCardEdit=true" // + this.executeCardEdit
      this.apiGet({url}).then(responseData => {
        this.items = {};
        this.items = responseData
        this.cardDatas = this.items.inspectionScheduleEquipmentVoList
      })
      // this.$store.dispatch("api/get", { url })
      //     .then(responseData => {
      //         this.items = responseData
      //     });
    },
    handleButtonHover(e) {
      this.popoverTarget = e.toElement.id
      console.log(this.popoverTarget)
    }
  },
  mounted() {
    //初始化点检列表
    this.getWorkOrderVo();
    //读取点巡检校验开关状态码
    this.getVerifyInspSwitchStatus();
  },
};
</script>
